{
  "name": "webapp",
  "version": "2026.0.3",
  "scripts": {
    "ng": "ng",
    "watch": "ng build --watch --configuration development",
    "start": "ng serve",
    "start-mock": "ng serve --c mock --open",
    "start-qa": "ng serve --c qa --open",
    "start-prod": "ng serve --c prod --open",
    "build": "ng build",
    "build:dev": "ng build --configuration development",
    "build:qa": "ng build --configuration qa",
    "build:staging": "ng build --configuration uat",
    "build:production": "ng build --configuration production",
    "test": "ng test",
    "lint": "ng lint --force",
    "e2e": "ng e2e",
    "build-qa": "node --max_old_space_size=10192 node_modules/@angular/cli/bin/ng build -c qa",
    "test:build": "ng build & ng build -c qa & ng build --prod"
  },
  "private": true,
  "packageManager": "npm@10.9.0",
  "dependencies": {
    "@angular/animations": "^21.0.0",
    "@angular/cdk": "^21.0.0",
    "@angular/common": "^21.2.0",
    "@angular/compiler": "^21.2.0",
    "@angular/core": "^21.2.0",
    "@angular/forms": "^21.2.0",
    "@angular/google-maps": "^21.0.0",
    "@angular/material": "^21.0.0",
    "@angular/material-moment-adapter": "^21.0.0",
    "@angular/platform-browser": "^21.2.0",
    "@angular/platform-browser-dynamic": "^21.0.0",
    "@angular/router": "^21.2.0",
    "@angular/service-worker": "^21.0.0",
    "@apollo/client": "^4.0.1",
    "@azure/msal-angular": "^3.0.0",
    "@azure/msal-browser": "^3.0.0",
    "@bluehalo/ngx-leaflet": "^21.0.0",
    "@bluehalo/ngx-leaflet-draw": "^21.1.3",
    "@here/maps-api-for-javascript": "^2.11.0",
    "apollo-angular": "^13.0.0",
    "bootstrap": "^5.3.0",
    "crypto-js": "^4.2.0",
    "file-saver": "^2.0.5",
    "graphql": "^16.0.0",
    "hammerjs": "^2.0.8",
    "highcharts": "^11.0.0",
    "jsbarcode": "^3.12.3",
    "leaflet": "^1.9.4",
    "leaflet-draw": "^1.0.2",
    "moment": "^2.30.0",
    "ngx-barcode6": "^1.0.0",
    "powerbi-client": "^2.23.0",
    "require": "^2.4.20",
    "rxjs": "^7.8.0",
    "tslib": "^2.6.0",
    "xlsx": "^0.18.0",
    "zone.js": "^0.16.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.0.0",
    "@angular/build": "^21.2.0",
    "@angular/cli": "^21.2.0",
    "@angular/compiler-cli": "^21.2.0",
    "@angular/language-service": "^21.0.0",
    "@types/google.maps": "^3.56.0",
    "@types/jasmine": "^5.0.0",
    "@types/leaflet": "^1.9.21",
    "@types/leaflet-draw": "^1.0.13",
    "@types/node": "^20.0.0",
    "jasmine-core": "^5.0.0",
    "jsdom": "^28.0.0",
    "karma": "^6.0.0",
    "karma-chrome-launcher": "^3.0.0",
    "karma-jasmine": "^5.0.0",
    "prettier": "^3.8.1",
    "typescript": "~5.9.2",
    "vitest": "^4.0.8"
  }
}
